var _a;
export class Ramadan {
}
_a = Ramadan;
Ramadan.firstDonationNight = 1;
Ramadan.donationNights = 29;
Ramadan.lastDonationNight = _a.firstDonationNight + _a.donationNights - 1;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmFtYWRhbi5qcyIsInNvdXJjZVJvb3QiOiJzcmMvIiwic291cmNlcyI6WyJjb25zdGFudHMvcmFtYWRhbi50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBQUEsTUFBTSxPQUFPLE9BQU87OztBQUNGLDBCQUFrQixHQUFHLENBQUMsQ0FBQTtBQUN0QixzQkFBYyxHQUFHLEVBQUUsQ0FBQTtBQUNuQix5QkFBaUIsR0FBRyxFQUFJLENBQUMsa0JBQWtCLEdBQUcsRUFBSSxDQUFDLGNBQWMsR0FBRyxDQUFDLENBQUEifQ==